export class Personal{
	public PERSON_ID:number;
	public NAME:string;
	public LAST_NAME:string;
	public MOTHER_LAST_NAME:string;
	public DATE_OF_BIRTH:any;
	public START_DATE:any;
	public CIVIL_STATUS:number;
	public GENDER:string;
	public RFC:string;
	public CURP:string;
	public MILITARY:string;
	public IMSS:string;
	public COUNTRY_ID:number;
	public STATE_ID:number;
	public CITY_ID:number;
	public ADDRESS:string;
	public COUNTY:string;
	public ZIP_CODE:string;
	public HOME_PHONE:string;
	public CELL_PHONE:string;
	public EMAIL:string;
	public EMPLOYEE_NUMBER:string;
	public EMPLOYEE_TYPE:number;
	public AR_CUSTOMER:number;
	public PERIODICITY:number;
	public AMOUNT:number;
	public SHIRT_SIZE:string;
	public JEANS_SIZE:string;
	public SHOE_SIZE:string;
	public PHOTO_BASE64:any;
	public Text1:string;
	public WAY_TO_PAY:string;
	public CARD_NUMBER:string;
	public WORKSHIFT:string;
	public DAY_OF_REST:string;
	public PAY_IMSS:boolean;
	public IMSS_TAX:number;
	public INFONAVIT_FLAG:boolean;
	public INFONAVIT:number;
	public REASON_NOT_IMSS:number;
	public SITE_ID:number;
	public PRIZE:number;
	public loacs: string;
}

export class PersonalPDF{
	public NAME:string;
	public DATE_OF_BIRTH:Date;
	public START_DATE:Date;
	public RFC:string;
	public CURP:string;
	public IMSS:string;
	public MILITARY:string;
	public ADDRESS:string;
	public COUNTY:string;
	public CITY:string;
	public ZIP_CODE:string;
	public HOME_PHONE:string;
	public CELL_PHONE:string;
	public EMAIL:string;
	public CIVIL_STATUS:string;
	public NAMEWIFE:string;
	public NUMSON:number;
	public DATA:string;	
	public MYMETYPE:string;	
	public MYME_TYPE:string;	
	public datosFamiliares:Array<any>;
	public documentos:Array<any>;
	public SOLICITUDEMPLEO:string;	
	public ACTANACIMIENTO:string;	
	public FOTOGRAFIA:string;	
	public IFE:string;	
	public CURPDOC:string;	
	public COMPDOMICILIO:string;	
	public CERTIFICADOESTUDIOS:string;	
	public CARTILLAMILITAR:string;	
	public COMPIMSS:string;	
	public NOANTECEDENTES:string;	
	public CARTARECOMENDACION:string;	
	public RFCDOC:string;	
}


// WEBPACK FOOTER //
// ./src/app/models/personal.ts